import { render } from "./OfficeLocation.vue?vue&type=template&id=dc5d699c&scoped=true"
import script from "./OfficeLocation.vue?vue&type=script&lang=js"
export * from "./OfficeLocation.vue?vue&type=script&lang=js"

import "./OfficeLocation.vue?vue&type=style&index=0&id=dc5d699c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\HRIS BCK\\digajiin_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5d699c"]])

export default __exports__